var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4151:2596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5.14316C10.3812 5.14316 11.5 3.99245 11.5 2.57173C11.5 1.15102 10.3812 0.000305176 9 0.000305176C7.61875 0.000305176 6.5 1.15102 6.5 2.57173C6.5 3.99245 7.61875 5.14316 9 5.14316ZM9 6.42888C7.33125 6.42888 4 7.29031 4 9.00031V10.286H14V9.00031C14 7.29031 10.6687 6.42888 9 6.42888Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.31032L1.25 10.4575H2.08333L2.08333 5.31032H3.33334L1.66667 3.60033L0 5.31032H1.25Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4151:2596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10.4572,
    fill: "white",
    transform: "translate(0 0.000305176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSent);
export default __webpack_public_path__ + "static/media/icon_sent.b0cb950fd092fa9386ddab0343f0e4d5.svg";
export { ForwardRef as ReactComponent };